<script setup>
import AccordionItem from '~/components/accordion/AccordionItem.vue'
import { slugifyString } from '~/utils/slugify'

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: false,
    default: () => [],
  },
})
</script>

<template>
  <div
    :id="props.id"
    class="accordion"
  >
    <slot>
      <AccordionItem
        v-for="(item, index) in items"
        :id="slugifyString(item.title)"
        :key="index"
        :title="item.title"
        :content="item.content"
        :parent-id="id"
      />
    </slot>
  </div>
</template>

<style lang="scss" scoped>
.accordion {
  background-color: unset;
}
</style>
